<template>
  <div class="addHome" :class="{'disable-element' : disablePanel}">
    ADD HOME TO ROUTE
    <v-btn-toggle v-model="addtype" v-custom-outside-click="closeDropdown" class="home-add-type">
      <v-btn flat value="mls-number" style="width: 30%;">
        MLS #
      </v-btn>
      <v-btn
        flat
        value="req-homes"
        style="width: 70%;"
        :class="{'highlighter' : showHighlighter}"
      >
        Requested Homes
      </v-btn>
    </v-btn-toggle>
    <div v-if="addtype === 'mls-number'">
      <v-text-field
        v-model="numberTyped"
        label="Home MLS Number"
        outline
        @keyup.enter="searchMLS()"
      />
      <div class="mls-number-text">
        Enter an MLS Number above and search
        <br>to add new property in Requested Homes List
      </div>
      <v-btn
        v-if="numberTyped"
        round
        small
        color="blue lighten-1"
        class="white--text"
        @click.stop="searchMLS()"
      >
        Search for MLS#
      </v-btn>
    </div>
    <div v-if="addtype === 'req-homes'" class="selectHomeSquare">
      <v-toolbar id="addHomeToolbar" flat>
        <v-toolbar-items class="mx-auto">
          <v-btn outline flat color="primary" @click.stop="onSelectClick">
            Select
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <ul class="favorites-list">
        <li
          v-for="fav in requestedTourToAdd"
          :key="fav._id"
          @click.stop="fav.checkbox = !fav.checkbox"
        >
          <v-layout wrap>
            <v-flex xs10>
              {{ `${fav.Address.trim()}, ${fav.City}` }}
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                v-model="fav.checkbox"
                class="checkbox-favorite"
                hide-details
                @click="[]"
              />
            </v-flex>
          </v-layout>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isPastRoute } from '../../../../utils/routeUtils'
import { mapState } from 'vuex'

export default {
  props: {
    secondaryLayout: {
      type: Boolean,
      required: true
    },
    route: {
      type: Object,
      required: true
    },
    requestedTourToAdd: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      addtype: 'mls-address',
      numberTyped: ''
    }
  },

  computed: {
    ...mapState('agent', ['rhtValue']),

    disablePanel() {
      return this.secondaryLayout || (this.route && isPastRoute(this.route))
    },

    showHighlighter() {
      return this.rhtValue.data.length <= this.requestedTourToAdd.length
    }
  },

  methods: {
    closeDropdown() {
      if (this.addtype === 'req-homes') {
        this.addtype = null
      }
    },

    searchMLS() {
      if (this.numberTyped) {
        this.$emit('search-properties', this.numberTyped)
      }
    },

    onSelectClick() {
      this.closeDropdown()
      this.$emit('add-requested-homes')
    }
  }
}
</script>

<style lang="sass" scoped>
.addHome
  border: 1px solid $hwayzce
  text-align: center
  padding: 5%
  grid-area: addHome
  position: relative
  &.block-filled
    border: 1px solid $hwayzYellow

.disable-element
  @extend %disabled-state

.home-add-type
  margin: 20px 0
  width: 100%
  justify-content: center
  background-color: $hwayzec !important
  button
    color: #000 !important
    background-color: $hwayzec
    opacity: 1 !important

.highlighter
  border: .2rem solid $hwayzRed

.mls-number-text
  font-size: 1.2rem
  margin-top: -1rem
  margin-bottom: 1rem

.selectHomeSquare
  min-height: 400px
  width: 90%
  background-color: $hwayzec
  border-radius: 1%
  box-shadow: 2px 1px 20px $hwayzce
  position: absolute
  top: 40%
  z-index: 100

#addHomeToolbar
  padding: 2%
  button
    height: 40px

.favorites-list li
  font-size: 1.4rem
  padding: 5% !important
  margin: 2% !important
  text-align: left
  border-bottom: 1px solid $hwayzce
  cursor: pointer

.checkbox-favorite
  display: inline-flex !important
  float: right !important
  margin-top: 0 !important
  padding-top: 0 !important
</style>
